'use strict';

const $recContainer = $('.adobe-recommendations');
const $recProducts = $recContainer.find('.product-carousel-products');

module.exports = {
    load: function () {
        let config;
        try {
            config = JSON.parse($recContainer.attr('data-recommendation-conf'));
        } catch (error) {
            config = null;
        }

        if (config === undefined || config === null) return;
        if (!('adobe' in window) || !window.adobe) return;

        window.adobe.target.getOffer({
            mbox: config.mbox,
            params: config.params,
            success: function (offers) {
                window.adobe.target.applyOffer({
                    mbox: config.mbox,
                    offer: offers
                });
                if (offers && offers.length > 0 && offers[0].content) {
                    let targetUrl = config.url;
                    const genObj = JSON.parse(offers[0].content.replace(/[\r\n\t]/g, ''));
                    let skus = {};
                    if (genObj.override_target_result === 'true') {
                        if (typeof genObj.recommendedItems === 'object' && Array.isArray(genObj.recommendedItems) && genObj.recommendedItems.length > 0) {
                            let sku;
                            let id;
                            for (let k1 = 0; k1 < genObj.recommendedItems.length; k1++) {
                                sku = genObj.recommendedItems[k1].sku;
                                id = genObj.recommendedItems[k1].id;
                                if (sku && sku.length > 0) {
                                    skus['sku' + (k1 + 1)] = sku;
                                } else if (id && id.length > 0) {
                                    skus['sku' + (k1 + 1)] = id;
                                }
                            }
                        }
                        if (typeof genObj.activityDetails !== 'undefined') utag_data.activityDetails = genObj.activityDetails;
                        if (typeof genObj.visitorProfile !== 'undefined') utag_data.visitorProfile = genObj.visitorProfile;
                        if (typeof genObj.recommendedItems !== 'undefined') utag_data.recommendedItems = genObj.recommendedItems;
                    } else {
                        skus = genObj;
                    }
                    const keys = Object.keys(skus);
                    let key;
                    for (let cnt = 0; cnt < keys.length; cnt++) {
                        key = keys[cnt];
                        if (skus[key]) {
                            targetUrl += cnt === 0 ? '?' : '&';
                            targetUrl += key + '=' + skus[key];
                        }
                    }

                    $.ajax({
                        url: targetUrl,
                        success: function (data) {
                            if (!data || data.trim().length === 0) return;
                            $recContainer.closest('.product-carousel-container').addClass('margin-bottom');
                            $recProducts.html(data);
                            $recContainer.trigger('AdobeRecommendations:Loaded', {
                                maxSlides: config.maxSlides
                            });
                        }
                    });
                }
            },
            error: function (status, error) {
                console.error(status, error); // eslint-disable-line no-console
            },
            timeout: 5000
        });
    }
};
